import React from 'react';

function InfoIcon() {
    return (
        <svg
            style={{ minWidth: '1.125rem' }}
            width='18' height='18' viewBox='0 0 18 18'
            fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M9 0C4.0374 0 0 4.03724 0 8.99951C0 13.9619 4.0374 17.9991 9 17.9991C13.9626 17.9991 18 13.9619 18 8.99951C18 4.03724 13.9626 0 9 0ZM9 16.3628C4.93969 16.3628 1.63636 13.0597 1.63636 8.99956C1.63636 4.93947 4.93969 1.63636 9 1.63636C13.0603 1.63636 16.3636 4.93947 16.3636 8.99951C16.3636 13.0597 13.0603 16.3628 9 16.3628Z' fill='#50CD89' />
            <path d='M8.99994 7.09132C8.54809 7.09132 8.18176 7.45765 8.18176 7.90951V13.3631C8.18176 13.815 8.54809 14.1813 8.99994 14.1813C9.4518 14.1813 9.81813 13.815 9.81813 13.3631V7.90951C9.81813 7.45771 9.4518 7.09132 8.99994 7.09132Z' fill='#50CD89' />
            <path d='M8.99994 3.81859C8.78449 3.81859 8.57389 3.90586 8.42122 4.05804C8.26904 4.21022 8.18176 4.42132 8.18176 4.63677C8.18176 4.85222 8.26904 5.06277 8.42122 5.2155C8.5734 5.36768 8.78449 5.45495 8.99994 5.45495C9.2154 5.45495 9.42594 5.36768 9.57862 5.2155C9.7308 5.06277 9.81813 4.85222 9.81813 4.63677C9.81813 4.42132 9.7308 4.21022 9.57862 4.05804C9.42594 3.90581 9.2154 3.81859 8.99994 3.81859Z' fill='#50CD89' />
        </svg>
    );
}

export default React.memo(InfoIcon);
